import { useQuery } from '@apollo/client'
import Step1Image from 'assets/images/project_management/modals/upsell_projects_in_tasks_modal/step_1.svg'
import Step2Image from 'assets/images/project_management/modals/upsell_projects_in_tasks_modal/step_2.svg'
import Step3Image from 'assets/images/project_management/modals/upsell_projects_in_tasks_modal/step_3.svg'
import Step4Image from 'assets/images/project_management/modals/upsell_projects_in_tasks_modal/step_4.svg'
import Step5Image from 'assets/images/project_management/modals/upsell_projects_in_tasks_modal/step_5.svg'
import { LOCAL_STORAGE_KEYS_FACTORIAL_TIPS } from 'config/Vars'
import { AvailableModules, Features } from 'generated/featureDefinitions'
import { CanSeeUpsellProjectsInTasksModalDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import UpsellModal from 'modules/upsell/components/UpsellModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

import { ProjectsUpsellRequestSources } from '../../upsells/constants'

const UpsellProjectsInTasksModal = () => {
  const { company } = useCurrentSession()

  const [upsellProjectsInTasksModalIsHidden, setUpsellProjectsInTasksModalIsHidden] =
    useLocalStorage<boolean>(LOCAL_STORAGE_KEYS_FACTORIAL_TIPS.hideProjectsUpsellTaskModal)

  const { data, loading } = useQuery(CanSeeUpsellProjectsInTasksModalDocument, {
    variables: {
      companyId: company.id,
      featureIds: [Features.projects_tasks],
    },
  })
  const showProjectsUpsellModal = data?.tasks._policies.showProjectsUpsellModal.can
  const hasProjectTasks = !!data?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_tasks
  )

  if (
    upsellProjectsInTasksModalIsHidden ||
    hasProjectTasks ||
    loading ||
    !showProjectsUpsellModal
  ) {
    return null
  }

  const handleModalClose = () => {
    setUpsellProjectsInTasksModalIsHidden(true)
  }

  const steps = [
    {
      src: Step1Image,
      title: i18n.t('project_management.modals.upsell_projects_in_tasks_modal.step_1.title'),
      description: i18n.t(
        'project_management.modals.upsell_projects_in_tasks_modal.step_1.description'
      ),
    },
    {
      src: Step2Image,
      title: i18n.t('project_management.modals.upsell_projects_in_tasks_modal.step_2.title'),
      description: i18n.t(
        'project_management.modals.upsell_projects_in_tasks_modal.step_2.description'
      ),
    },
    {
      src: Step3Image,
      title: i18n.t('project_management.modals.upsell_projects_in_tasks_modal.step_3.title'),
      description: i18n.t(
        'project_management.modals.upsell_projects_in_tasks_modal.step_3.description'
      ),
    },
    {
      src: Step4Image,
      title: i18n.t('project_management.modals.upsell_projects_in_tasks_modal.step_4.title'),
      description: i18n.t(
        'project_management.modals.upsell_projects_in_tasks_modal.step_4.description'
      ),
    },
    {
      src: Step5Image,
      title: i18n.t('project_management.modals.upsell_projects_in_tasks_modal.step_5.title'),
      description: i18n.t(
        'project_management.modals.upsell_projects_in_tasks_modal.step_5.description'
      ),
    },
  ]

  return (
    <UpsellModal.Image
      stepsContent={steps}
      requestDetail={{
        moduleRequested: AvailableModules.projects,
        requestReason: ValidReasons.MissingAddon,
        featureRequested: Features.projects_tasks,
        requestSource: ProjectsUpsellRequestSources.tasksCore.toString(),
      }}
      onClose={handleModalClose}
      buttonLabel={i18n.t('project_management.modals.upsell_projects_in_tasks_modal.button_label')}
    />
  )
}

export default UpsellProjectsInTasksModal
